// extracted by mini-css-extract-plugin
export default {"control":"control_control__f0PkZ","button":"control_button__0UrqD"};